module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-452.9ec0ec8.woff2";